import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import SchoolIcon from "@mui/icons-material/School";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import FactoryIcon from "@mui/icons-material/Factory";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import MuseumIcon from "@mui/icons-material/Museum";
import ChurchIcon from "@mui/icons-material/Church";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import NatureIcon from "@mui/icons-material/Nature";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import { ReactElement } from "react";

const iconMap: Record<string, ReactElement> = {
  ApartmentIcon: <ApartmentIcon />,
  BusinessIcon: <BusinessIcon />,
  StorefrontIcon: <StorefrontIcon />,
  HomeWorkIcon: <HomeWorkIcon />,
  LocalHospitalIcon: <LocalHospitalIcon />,
  SchoolIcon: <SchoolIcon />,
  LocalLibraryIcon: <LocalLibraryIcon />,
  FactoryIcon: <FactoryIcon />,
  WarehouseIcon: <WarehouseIcon />,
  LocalCafeIcon: <LocalCafeIcon />,
  RestaurantIcon: <RestaurantIcon />,
  LocalGroceryStoreIcon: <LocalGroceryStoreIcon />,
  MuseumIcon: <MuseumIcon />,
  ChurchIcon: <ChurchIcon />,
  LocalPoliceIcon: <LocalPoliceIcon />,
  DirectionsBusIcon: <DirectionsBusIcon />,
  AirportShuttleIcon: <AirportShuttleIcon />,
  AccountBalanceIcon: <AccountBalanceIcon />,
  NatureIcon: <NatureIcon />,
  EmojiPeopleIcon: <EmojiPeopleIcon />,
};

export function getEntityIconByName(iconName: string): ReactElement | null {
  return iconMap[iconName] || null;
}
